import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="py-8 text-center text-gray-500 bg-gray-50 text-sm" data-id="element-45">
        <p className="mb-2" data-id="element-46">
          © {new Date().getFullYear()} Metabolismo Pro-Edad. Todos los derechos
          reservados.
        </p>
        <div className="flex items-center justify-center gap-3" data-id="element-47">
          <button onClick={() => setShowTerms(true)} className="underline underline-offset-2 text-gray-500 hover:text-amber-600 transition-colors" data-id="element-48">
            Términos y Condiciones
          </button>
          <span className="text-gray-300" data-id="element-49">|</span>
          <button onClick={() => setShowPrivacy(true)} className="underline underline-offset-2 text-gray-500 hover:text-amber-600 transition-colors" data-id="element-50">
            Política de Privacidad
          </button>
        </div>
      </footer>

      {/* Terms & Conditions Modal */}
      <AnimatePresence data-id="element-51">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-52">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="relative w-full max-w-2xl max-h-[80vh] bg-white rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-53">
              {/* Header */}
              <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 bg-white border-b border-gray-100" data-id="element-54">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-55">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setShowTerms(false)} className="flex items-center justify-center w-8 h-8 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-600 transition-colors" data-id="element-56">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-57">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-58" />
                  </svg>
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-left text-gray-700 leading-relaxed space-y-6" data-id="element-59">
                <section data-id="element-60">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-61">
                    1. Aceptación de los Términos
                  </h3>
                  <p data-id="element-62">
                    Al adquirir el programa "Metabolismo Pro-Edad", usted acepta
                    estos términos y condiciones en su totalidad. Si no está de
                    acuerdo con alguno de estos términos, le recomendamos no
                    realizar la compra.
                  </p>
                </section>

                <section data-id="element-63">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-64">
                    2. Naturaleza del Producto
                  </h3>
                  <p data-id="element-65">
                    "Metabolismo Pro-Edad" es un producto digital de carácter
                    educativo e informativo. El contenido proporcionado no
                    constituye asesoramiento médico, diagnóstico ni tratamiento.
                    Siempre consulte a un profesional de la salud antes de
                    iniciar cualquier programa de nutrición o ejercicio.
                  </p>
                </section>

                <section data-id="element-66">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-67">
                    3. Entrega del Producto
                  </h3>
                  <p data-id="element-68">
                    El acceso al producto digital se entrega de forma inmediata
                    a través de la plataforma Hotmart tras la confirmación del
                    pago. Recibirá un correo electrónico con las instrucciones
                    de acceso.
                  </p>
                </section>

                <section data-id="element-69">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-70">
                    4. Política de Reembolso
                  </h3>
                  <p data-id="element-71">
                    Ofrecemos una garantía de satisfacción de 7 días a partir de
                    la fecha de compra, conforme a las políticas de la
                    plataforma Hotmart. Si no está satisfecho con el producto,
                    puede solicitar un reembolso completo dentro de este
                    período.
                  </p>
                </section>

                <section data-id="element-72">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-73">
                    5. Propiedad Intelectual
                  </h3>
                  <p data-id="element-74">
                    Todo el contenido del programa, incluyendo textos, gráficos,
                    guías y materiales complementarios, está protegido por
                    derechos de autor. Queda prohibida la reproducción,
                    distribución o reventa total o parcial del material sin
                    autorización expresa.
                  </p>
                </section>

                <section data-id="element-75">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-76">
                    6. Resultados
                  </h3>
                  <p data-id="element-77">
                    Los resultados pueden variar de persona a persona. Los
                    testimonios y ejemplos mencionados en la página de venta
                    representan experiencias individuales y no garantizan
                    resultados idénticos para todos los usuarios.
                  </p>
                </section>

                <section data-id="element-78">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-79">
                    7. Limitación de Responsabilidad
                  </h3>
                  <p data-id="element-80">
                    El creador del programa no se hace responsable de cualquier
                    daño directo o indirecto derivado del uso o la incapacidad
                    de uso del material proporcionado. El usuario asume toda la
                    responsabilidad por las decisiones tomadas basándose en el
                    contenido del programa.
                  </p>
                </section>

                <section data-id="element-81">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-82">
                    8. Modificaciones
                  </h3>
                  <p data-id="element-83">
                    Nos reservamos el derecho de modificar estos términos y
                    condiciones en cualquier momento. Las modificaciones
                    entrarán en vigor a partir de su publicación. El uso
                    continuado del producto después de dichas modificaciones
                    constituye la aceptación de los nuevos términos.
                  </p>
                </section>

                <p className="pt-4 text-sm text-gray-400 border-t border-gray-100" data-id="element-84">
                  Última actualización: Marzo 2026
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-85">
        {showPrivacy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-86">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="relative w-full max-w-2xl max-h-[80vh] bg-white rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-87">
              <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 bg-white border-b border-gray-100" data-id="element-88">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-89">
                  Política de Privacidad
                </h2>
                <button onClick={() => setShowPrivacy(false)} className="flex items-center justify-center w-8 h-8 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-600 transition-colors" data-id="element-90">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-91">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-92" />
                  </svg>
                </button>
              </div>

              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-left text-gray-700 leading-relaxed space-y-6" data-id="element-93">
                <section data-id="element-94">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-95">
                    1. Información que Recopilamos
                  </h3>
                  <p data-id="element-96">
                    Al adquirir "Metabolismo Pro-Edad", recopilamos únicamente
                    la información necesaria para procesar su compra y entregar
                    el producto: nombre, dirección de correo electrónico y datos
                    de pago. Los datos de pago son procesados directamente por
                    Hotmart y no son almacenados en nuestros servidores.
                  </p>
                </section>

                <section data-id="element-97">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-98">
                    2. Uso de la Información
                  </h3>
                  <p data-id="element-99">Utilizamos su información personal exclusivamente para:</p>
                  <ul className="mt-2 ml-4 space-y-1 list-disc list-inside text-gray-600" data-id="element-100">
                    <li data-id="element-101">Procesar y entregar su compra</li>
                    <li data-id="element-102">
                      Enviar el acceso al producto digital por correo
                      electrónico
                    </li>
                    <li data-id="element-103">
                      Comunicar actualizaciones importantes sobre el programa
                    </li>
                    <li data-id="element-104">Brindar soporte al cliente cuando sea solicitado</li>
                  </ul>
                </section>

                <section data-id="element-105">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-106">
                    3. Protección de Datos
                  </h3>
                  <p data-id="element-107">
                    Implementamos medidas de seguridad técnicas y organizativas
                    para proteger su información personal contra acceso no
                    autorizado, alteración, divulgación o destrucción. Toda la
                    comunicación se realiza a través de conexiones cifradas
                    (SSL/TLS).
                  </p>
                </section>

                <section data-id="element-108">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-109">
                    4. Compartir Información con Terceros
                  </h3>
                  <p data-id="element-110">
                    No vendemos, alquilamos ni compartimos su información
                    personal con terceros con fines comerciales. Solo
                    compartimos datos con la plataforma Hotmart en la medida
                    necesaria para procesar su transacción y entregar el
                    producto.
                  </p>
                </section>

                <section data-id="element-111">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-112">
                    5. Cookies y Tecnologías de Seguimiento
                  </h3>
                  <p data-id="element-113">
                    Nuestro sitio web puede utilizar cookies y tecnologías
                    similares para mejorar la experiencia del usuario y analizar
                    el tráfico del sitio. Puede configurar su navegador para
                    rechazar cookies, aunque esto podría afectar la
                    funcionalidad del sitio.
                  </p>
                </section>

                <section data-id="element-114">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-115">
                    6. Sus Derechos
                  </h3>
                  <p data-id="element-116">Usted tiene derecho a:</p>
                  <ul className="mt-2 ml-4 space-y-1 list-disc list-inside text-gray-600" data-id="element-117">
                    <li data-id="element-118">
                      Acceder a sus datos personales que tenemos almacenados
                    </li>
                    <li data-id="element-119">Solicitar la corrección de datos inexactos</li>
                    <li data-id="element-120">Solicitar la eliminación de sus datos personales</li>
                    <li data-id="element-121">
                      Retirar su consentimiento para el uso de sus datos en
                      cualquier momento
                    </li>
                  </ul>
                </section>

                <section data-id="element-122">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-123">
                    7. Retención de Datos
                  </h3>
                  <p data-id="element-124">
                    Conservamos su información personal únicamente durante el
                    tiempo necesario para cumplir con los fines descritos en
                    esta política, o según lo requieran las obligaciones legales
                    aplicables.
                  </p>
                </section>

                <section data-id="element-125">
                  <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-126">
                    8. Cambios en esta Política
                  </h3>
                  <p data-id="element-127">
                    Nos reservamos el derecho de actualizar esta política de
                    privacidad en cualquier momento. Cualquier cambio será
                    publicado en esta página con la fecha de actualización
                    correspondiente.
                  </p>
                </section>

                <p className="pt-4 text-sm text-gray-400 border-t border-gray-100" data-id="element-128">
                  Última actualización: Marzo 2026
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}